import React from 'react';
import {ChatbotDispatch, ChatbotState, LATConfig} from 'types';

import {useBranding} from 'context/Branding';
import {useWindowWidth} from 'context/Responsive';

import UnstyledButton from '../../@spaced-out/components/button/unstyled';
import {useClickaway} from 'utils/use-clickaway';
import headerCss from './Header.module.css';

const AudioMuteIcon = ({color}: {color?: string}) => (
  <svg
    className={headerCss.controlIcon}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.53038 2.46967C3.23748 2.17678 2.76261 2.17678 2.46972 2.46967C2.17682 2.76256 2.17682 3.23744 2.46972 3.53033L6.18939 7.25L6.00005 7.25L5.88425 7.24998L5.88424 7.24998C5.06628 7.24971 4.50814 7.24952 4.02948 7.37778C2.73538 7.72453 1.72458 8.73533 1.37783 10.0294C1.24957 10.5081 1.24975 11.0662 1.25002 11.8842L1.25005 12L1.25002 12.1158C1.24975 12.9338 1.24957 13.4919 1.37783 13.9706C1.72458 15.2647 2.73538 16.2755 4.02948 16.6222C4.50814 16.7505 5.06629 16.7503 5.88425 16.75L6.00005 16.75L6.49172 16.75C6.94963 16.75 7.07327 16.7536 7.17932 16.7752C7.41807 16.8238 7.63739 16.9412 7.81032 17.1129C7.88712 17.1891 7.95868 17.29 8.21268 17.671L8.22706 17.6926C8.8135 18.5723 9.27178 19.2597 9.64355 19.7551C9.99525 20.2238 10.3593 20.6504 10.7783 20.8581C12.0796 21.5035 13.6584 21.0255 14.3832 19.7666C14.6166 19.3613 14.6829 18.8045 14.7155 18.2194C14.749 17.6193 14.75 16.8234 14.75 15.8107L20.4697 21.5303C20.7626 21.8232 21.2375 21.8232 21.5304 21.5303C21.8233 21.2374 21.8233 20.7626 21.5304 20.4697L14.5304 13.4697L8.33084 7.27013L3.53038 2.46967ZM7.47889 8.6946C7.52126 8.68596 7.56336 8.67634 7.60514 8.66576L13.25 14.3107L13.25 15.6917C13.25 16.7803 13.2498 17.5644 13.2179 18.1359C13.1838 18.7458 13.1167 18.9602 13.0833 19.0182C12.7539 19.5904 12.0362 19.8076 11.4447 19.5143C11.3847 19.4846 11.21 19.3434 10.8433 18.8548C10.4998 18.397 10.0646 17.7448 9.46076 16.839L9.42531 16.7858L9.4253 16.7858C9.22347 16.4827 9.06517 16.245 8.86708 16.0483C8.48665 15.6707 8.00414 15.4125 7.47889 15.3054C7.20538 15.2497 6.9198 15.2498 6.55566 15.25L6.49172 15.25L6.00005 15.25C5.02179 15.25 4.67979 15.2436 4.4177 15.1733C3.64125 14.9653 3.03477 14.3588 2.82671 13.5823C2.75649 13.3203 2.75005 12.9783 2.75005 12C2.75005 11.0217 2.75649 10.6797 2.82671 10.4177C3.03477 9.6412 3.64125 9.03472 4.4177 8.82667C4.67979 8.75644 5.02179 8.75 6.00005 8.75L6.49172 8.75L6.55565 8.75002C6.9198 8.7502 7.20538 8.75035 7.47889 8.6946ZM14.3832 4.23335C13.6584 2.97454 12.0796 2.49651 10.7783 3.14186C10.4569 3.30122 10.1827 3.57888 9.93648 3.8731C9.67948 4.18023 9.39033 4.58409 9.05356 5.07675C8.8198 5.4187 8.90751 5.8854 9.24946 6.11916C9.59142 6.35291 10.0581 6.2652 10.2919 5.92325C10.6257 5.43485 10.8801 5.08282 11.0869 4.83572C11.3044 4.57572 11.4143 4.50079 11.4447 4.48569C12.0362 4.19235 12.7539 4.40964 13.0833 4.98183C13.1167 5.03984 13.1838 5.25423 13.2179 5.86415C13.2498 6.43562 13.25 7.21971 13.25 8.30833L13.25 10C13.25 10.4142 13.5858 10.75 14 10.75C14.4143 10.75 14.75 10.4142 14.75 10L14.75 8.30833L14.75 8.28237L14.75 8.28233C14.75 7.22514 14.7501 6.39899 14.7155 5.78056C14.6829 5.1955 14.6166 4.63866 14.3832 4.23335ZM17.3763 5.58348C17.6064 5.23902 18.0721 5.14625 18.4166 5.37629C20.4358 6.72479 21.75 9.20742 21.75 12C21.75 13.1734 21.5185 14.2891 21.1019 15.2886C20.9409 15.6748 20.7521 16.0439 20.5383 16.3923C20.3216 16.7453 19.8598 16.8559 19.5068 16.6392C19.1537 16.4225 19.0432 15.9607 19.2599 15.6077C19.4326 15.3263 19.5859 15.0267 19.7174 14.7114C20.0575 13.8955 20.25 12.976 20.25 12C20.25 9.66489 19.1511 7.67052 17.5835 6.62371C17.2391 6.39367 17.1463 5.92795 17.3763 5.58348ZM16.3763 9.58348C16.6064 9.23902 17.0721 9.14625 17.4166 9.37629C18.2402 9.92635 18.75 10.9167 18.75 12C18.75 12.457 18.6599 12.8943 18.4955 13.2886C18.3361 13.6709 17.897 13.8516 17.5147 13.6923C17.1323 13.5329 16.9516 13.0937 17.111 12.7114C17.1989 12.5006 17.25 12.2595 17.25 12C17.25 11.3741 16.9555 10.8721 16.5835 10.6237C16.2391 10.3937 16.1463 9.92795 16.3763 9.58348Z"
      fill={color}
    />
  </svg>
);

const AudioOnIcon = ({color}: {color?: string}) => (
  <svg
    className={headerCss.controlIcon}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3832 4.23347C13.6584 2.97466 12.0796 2.49663 10.7783 3.14198C10.3593 3.34976 9.99525 3.77632 9.64355 4.245C9.27178 4.74043 8.81351 5.42784 8.22707 6.3075L8.21268 6.32909C7.95868 6.71009 7.88712 6.81099 7.81032 6.88724C7.63739 7.0589 7.41807 7.17628 7.17932 7.22494C7.07327 7.24655 6.94963 7.25012 6.49172 7.25012L6.00005 7.25012L5.88425 7.2501C5.06629 7.24983 4.50814 7.24964 4.02948 7.3779C2.73538 7.72465 1.72458 8.73545 1.37783 10.0295C1.24957 10.5082 1.24975 11.0664 1.25002 11.8843L1.25005 12.0001L1.25002 12.1159C1.24975 12.9339 1.24957 13.492 1.37783 13.9707C1.72458 15.2648 2.73538 16.2756 4.02948 16.6223C4.50813 16.7506 5.06627 16.7504 5.88421 16.7501L5.88426 16.7501L6.00005 16.7501L6.49172 16.7501C6.94963 16.7501 7.07327 16.7537 7.17932 16.7753C7.41807 16.824 7.63739 16.9413 7.81032 17.113C7.88712 17.1892 7.95868 17.2901 8.21268 17.6711L8.2271 17.6928C8.81352 18.5724 9.27179 19.2598 9.64355 19.7552C9.99525 20.2239 10.3593 20.6505 10.7783 20.8583C12.0796 21.5036 13.6584 21.0256 14.3832 19.7668C14.6166 19.3615 14.6829 18.8046 14.7155 18.2196C14.7501 17.6011 14.7501 16.775 14.75 15.7178L14.75 15.7178L14.75 15.6918L14.75 8.30844L14.75 8.28249L14.75 8.28245C14.75 7.22526 14.7501 6.39911 14.7155 5.78068C14.6829 5.19562 14.6166 4.63878 14.3832 4.23347ZM11.4447 4.48581C12.0362 4.19247 12.7539 4.40976 13.0833 4.98195C13.1167 5.03996 13.1838 5.25435 13.2179 5.86426C13.2498 6.43574 13.25 7.21983 13.25 8.30844L13.25 15.6918C13.25 16.7804 13.2498 17.5645 13.2179 18.136C13.1838 18.7459 13.1167 18.9603 13.0833 19.0183C12.7539 19.5905 12.0362 19.8078 11.4447 19.5144C11.3847 19.4847 11.21 19.3435 10.8433 18.8549C10.4998 18.3971 10.0646 17.7449 9.46075 16.8391L9.42532 16.7859C9.22347 16.4828 9.06518 16.2451 8.86708 16.0485C8.48665 15.6708 8.00414 15.4126 7.47889 15.3055C7.20538 15.2498 6.91981 15.2499 6.55566 15.2501L6.55564 15.2501L6.49172 15.2501L6.00005 15.2501C5.02179 15.2501 4.67979 15.2437 4.41771 15.1735C3.64125 14.9654 3.03477 14.3589 2.82671 13.5825C2.75649 13.3204 2.75005 12.9784 2.75005 12.0001C2.75005 11.0219 2.75649 10.6799 2.82671 10.4178C3.03477 9.64132 3.64125 9.03484 4.4177 8.82679C4.67979 8.75656 5.02179 8.75012 6.00005 8.75012L6.49172 8.75012L6.55566 8.75014L6.55566 8.75014C6.9198 8.75032 7.20538 8.75047 7.47889 8.69472C8.00414 8.58767 8.48665 8.32943 8.86708 7.95178C9.06517 7.75514 9.22346 7.51744 9.4253 7.21436L9.46075 7.16114C10.0646 6.25536 10.4998 5.60312 10.8433 5.14531C11.21 4.65672 11.3847 4.51556 11.4447 4.48581ZM17.3763 5.5836C17.6064 5.23914 18.0721 5.14637 18.4166 5.37641C20.4359 6.72491 21.75 9.20754 21.75 12.0001C21.75 14.7927 20.4359 17.2753 18.4166 18.6238C18.0721 18.8539 17.6064 18.7611 17.3763 18.4166C17.1463 18.0722 17.2391 17.6064 17.5835 17.3764C19.1511 16.3296 20.25 14.3352 20.25 12.0001C20.25 9.66501 19.1511 7.67064 17.5835 6.62383C17.2391 6.39379 17.1463 5.92807 17.3763 5.5836ZM16.3763 9.5836C16.6064 9.23914 17.0721 9.14637 17.4166 9.37641C18.2402 9.92647 18.75 10.9168 18.75 12.0001C18.75 13.0835 18.2402 14.0738 17.4166 14.6238C17.0721 14.8539 16.6064 14.7611 16.3763 14.4166C16.1463 14.0722 16.2391 13.6064 16.5835 13.3764C16.9555 13.128 17.25 12.626 17.25 12.0001C17.25 11.3742 16.9555 10.8722 16.5835 10.6238C16.2391 10.3938 16.1463 9.92807 16.3763 9.5836Z"
      fill={color}
    />
  </svg>
);

const RefreshIcon = ({color}: {color?: string}) => (
  <svg
    className={headerCss.controlIcon}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.02271 4.17153C5.78332 2.71903 8.44644 1.25006 12 1.25006C17.9714 1.25006 22.75 6.0646 22.75 12.0001C22.75 17.9371 17.9371 22.7501 12 22.7501C6.06294 22.7501 1.25 17.9371 1.25 12.0001C1.25 11.5858 1.58579 11.2501 2 11.2501C2.41421 11.2501 2.75 11.5858 2.75 12.0001C2.75 17.1087 6.89137 21.2501 12 21.2501C17.1086 21.2501 21.25 17.1087 21.25 12.0001C21.25 6.88983 17.1397 2.75006 12 2.75006C8.88689 2.75006 6.55001 4.0311 4.97729 5.32859C4.37296 5.82716 3.88464 6.32585 3.51309 6.75006H5.5C5.91421 6.75006 6.25 7.08585 6.25 7.50006C6.25 7.91427 5.91421 8.25006 5.5 8.25006H2C1.58579 8.25006 1.25 7.91427 1.25 7.50006V4.00006C1.25 3.58585 1.58579 3.25006 2 3.25006C2.41421 3.25006 2.75 3.58585 2.75 4.00006V5.36069C3.10527 4.98541 3.52941 4.57851 4.02271 4.17153Z"
      fill={color}
    />
  </svg>
);

const MoreVert = ({color}: {color?: string}) => (
  <svg
    className={headerCss.controlIcon}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 4.5C8.25 2.71079 9.71079 1.25 11.5 1.25C13.2892 1.25 14.75 2.71079 14.75 4.5C14.75 6.28921 13.2892 7.75 11.5 7.75C9.71079 7.75 8.25 6.28921 8.25 4.5ZM11.5 2.75C10.5392 2.75 9.75 3.53921 9.75 4.5C9.75 5.46079 10.5392 6.25 11.5 6.25C12.4608 6.25 13.25 5.46079 13.25 4.5C13.25 3.53921 12.4608 2.75 11.5 2.75ZM8.25 12C8.25 10.2108 9.71079 8.75 11.5 8.75C13.2892 8.75 14.75 10.2108 14.75 12C14.75 13.7892 13.2892 15.25 11.5 15.25C9.71079 15.25 8.25 13.7892 8.25 12ZM11.5 10.25C10.5392 10.25 9.75 11.0392 9.75 12C9.75 12.9608 10.5392 13.75 11.5 13.75C12.4608 13.75 13.25 12.9608 13.25 12C13.25 11.0392 12.4608 10.25 11.5 10.25ZM11.5 16.25C9.71079 16.25 8.25 17.7108 8.25 19.5C8.25 21.2892 9.71079 22.75 11.5 22.75C13.2892 22.75 14.75 21.2892 14.75 19.5C14.75 17.7108 13.2892 16.25 11.5 16.25ZM9.75 19.5C9.75 18.5392 10.5392 17.75 11.5 17.75C12.4608 17.75 13.25 18.5392 13.25 19.5C13.25 20.4608 12.4608 21.25 11.5 21.25C10.5392 21.25 9.75 20.4608 9.75 19.5Z"
      fill={color}
    />
  </svg>
);

const CloseIcon = ({color}: {color?: string}) => (
  <svg
    className={headerCss.controlIcon}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
      fill={color}
    />
  </svg>
);

const HeaderContextMenu = ({
  faqEnabled,
  latConfig,
  color,
  dispatch,
  onPostMessage,
}: {
  faqEnabled?: boolean;
  latConfig?: LATConfig;
  color?: string;
  dispatch: ChatbotDispatch;
  onPostMessage: (text: string, payload?: string | string[]) => unknown;
}) => {
  const ctxMenuIconVisible = faqEnabled || latConfig?.show_lat_button;
  const {isOpen, toggle: toggleContextMenu} = useClickaway();

  const handleClickToggleShowFAQ = () => {
    dispatch({type: 'toggle_show_faq'});
  };

  const handleClickChatWithRecruiter = () => {
    onPostMessage('I want to talk to a human', 'I want to talk to an agent');
  };

  const contextMenuLabel = isOpen
    ? 'Close chatbot context menu'
    : 'Open chatbot context menu';

  return (
    <>
      {ctxMenuIconVisible && (
        <div className={headerCss.verticalButton}>
          <UnstyledButton
            aria-label={contextMenuLabel}
            onClick={toggleContextMenu}
          >
            <MoreVert color={color} />
          </UnstyledButton>
          {isOpen && (
            <div className={headerCss.contextMenu}>
              <ul>
                {faqEnabled && (
                  <li>
                    <button onClick={handleClickToggleShowFAQ}>
                      Frequently asked questions
                    </button>
                  </li>
                )}
                {latConfig?.show_lat_button &&
                  latConfig.enable_keyword_trigger && (
                    <li>
                      <button onClick={handleClickChatWithRecruiter}>
                        {latConfig?.button_label ?? 'Chat with a recruiter'}
                      </button>
                    </li>
                  )}
              </ul>
            </div>
          )}
        </div>
      )}
    </>
  );
};

const NamedMobileHeader = ({
  name,
  description,
  handleLogoClick,
  // Unused in mobile header, but we might in the future
  displayName,
  dispatch,
  state,
  isMobile,
  chatbotFaqEnabled,
  inputDisabled,
  headerLogo = false,
  onPostMessage,
}: {
  name: string;
  description: string;
  handleLogoClick?: () => void;
  displayName?: string;
  dispatch: ChatbotDispatch;
  state: ChatbotState;
  isMobile?: boolean;
  chatbotFaqEnabled?: boolean;
  inputDisabled?: boolean;
  headerLogo?: boolean;
  onPostMessage: (text: string, payload?: string | string[]) => unknown;
}) => {
  const flowBrandSettings = useBranding();

  return (
    <header className={headerCss.inboundHeader}>
      {headerLogo ? (
        <div className={headerCss.botName}>
          <img
            style={{maxWidth: 140, maxHeight: 35}}
            src={flowBrandSettings?.logo}
            alt="logo"
          />
        </div>
      ) : (
        <div className={headerCss.botName} tabIndex={0}>
          <h2>{flowBrandSettings?.chatbot_bot_name ?? name}</h2>
          <p>{flowBrandSettings?.chatbot_bot_tagline ?? description}</p>
        </div>
      )}
      <div className={headerCss.inboundHeaderControls}>
        {/*DUPE: marcos/extra controls*/}
        {flowBrandSettings.chatbot_audio_enabled && (
          <UnstyledButton
            className={headerCss.appControls}
            aria-label={
              state.muteChime
                ? 'Mute audible chatbot notifications'
                : 'Enable audible chatbot notifications'
            }
            onClick={() =>
              dispatch({type: 'toggle_mute_chime', payload: !state.muteChime})
            }
          >
            {state.muteChime ? (
              <AudioMuteIcon color={flowBrandSettings?.button_color} />
            ) : (
              <AudioOnIcon color={flowBrandSettings?.button_color} />
            )}
          </UnstyledButton>
        )}

        <UnstyledButton
          className={headerCss.appControls}
          aria-label="Restart conversation"
          onClick={() => {
            dispatch({type: 'clear_conversation'});
          }}
        >
          <RefreshIcon color={flowBrandSettings?.button_color} />
        </UnstyledButton>
        {isMobile && (
          <UnstyledButton
            className={headerCss.controlIcon}
            aria-label="Close chatbot"
            onClick={handleLogoClick}
          >
            <CloseIcon color={flowBrandSettings?.button_color} />
          </UnstyledButton>
        )}
        <HeaderContextMenu
          color={flowBrandSettings?.button_color}
          faqEnabled={chatbotFaqEnabled}
          latConfig={state.conversation?.flow.lat_config}
          dispatch={dispatch}
          onPostMessage={onPostMessage}
        />
      </div>
    </header>
  );
};

const Header = ({
  handleLogoClick,
  logo,
  name,
  description,
  displayName,
  dispatch,
  state,
  isMobile,
  chatbotFaqEnabled,
  inputDisabled,
  onPostMessage,
}: {
  handleLogoClick?: () => void;
  logo?: string;
  name?: string;
  description?: string;
  displayName?: string;
  dispatch: ChatbotDispatch;
  state: ChatbotState;
  isMobile?: boolean;
  chatbotFaqEnabled?: boolean;
  inputDisabled?: boolean;
  onPostMessage: (text: string, payload?: string | string[]) => unknown;
}) => {
  const flowBrandSettings = useBranding();
  const {context: botContext} = useWindowWidth();

  const [prefersHeader, setPrefersHeader] = React.useState(
    Boolean(flowBrandSettings.chatbot_uses_logo_for_header),
  );

  React.useEffect(() => {
    // this is a special case for staffmark that sets the header
    if (window.location.host.split('.')[0] === 'recruit') {
      setPrefersHeader(true);
    } else {
      setPrefersHeader(Boolean(flowBrandSettings.chatbot_uses_logo_for_header));
    }
  }, [flowBrandSettings]);

  return botContext !== 'desktop' ? (
    <NamedMobileHeader
      name={name ?? 'Reva'}
      description={description ?? 'Recruiting Assistant'}
      displayName={displayName ?? 'Sense'}
      handleLogoClick={handleLogoClick}
      dispatch={dispatch}
      state={state}
      isMobile={isMobile}
      chatbotFaqEnabled={chatbotFaqEnabled}
      inputDisabled={inputDisabled}
      headerLogo={prefersHeader}
      onPostMessage={onPostMessage}
    />
  ) : null;
};

export const NamedDesktopHeader = ({
  name = 'Reva',
  description = 'Recruiting Virtual Assistant',
  state,
  dispatch,
  chatbotFaqEnabled,
  inputDisabled,
  onPostMessage,
}: {
  name: string;
  description: string;
  state: ChatbotState;
  dispatch: ChatbotDispatch;
  chatbotFaqEnabled?: boolean;
  inputDisabled?: boolean;
  onPostMessage: (text: string, payload?: string | string[]) => unknown;
}) => {
  const flowBrandSettings = useBranding();

  return (
    <div className={headerCss.namedHeader}>
      <div className={headerCss.headerTitles} tabIndex={0}>
        <h1 className={headerCss.headerTitle}>{name}</h1>
        <p className={headerCss.headerSubtitle}>{description}</p>
      </div>

      <div className={headerCss.desktopHeaderControls}>
        {/*DUPE: marcos/extra controls*/}
        {flowBrandSettings.chatbot_audio_enabled && (
          <UnstyledButton
            className={headerCss.appControls}
            aria-label={
              state.muteChime
                ? 'Mute audible chatbot notifications'
                : 'Enable audible chatbot notifications'
            }
            onClick={() =>
              dispatch({type: 'toggle_mute_chime', payload: !state.muteChime})
            }
          >
            {state.muteChime ? (
              <AudioMuteIcon color={flowBrandSettings?.button_color} />
            ) : (
              <AudioOnIcon color={flowBrandSettings?.button_color} />
            )}
          </UnstyledButton>
        )}

        <UnstyledButton
          className={headerCss.appControls}
          aria-label="Restart conversation"
          onClick={() => {
            dispatch({type: 'clear_conversation'});
          }}
        >
          <RefreshIcon color={flowBrandSettings?.button_color} />
        </UnstyledButton>

        <HeaderContextMenu
          color={flowBrandSettings?.button_color}
          faqEnabled={chatbotFaqEnabled}
          latConfig={state.conversation?.flow?.lat_config}
          dispatch={dispatch}
          onPostMessage={onPostMessage}
        />
      </div>
    </div>
  );
};

export default Header;
